// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9f79bb7a854ae83c6241","678":"ba6cfd493c562fc37505","883":"afd26c6af02ee68e9333"}[chunkId] + ".js";
};